import { render } from "./Forgot.vue?vue&type=template&id=698480a3&scoped=true"
import script from "./Forgot.vue?vue&type=script&lang=js"
export * from "./Forgot.vue?vue&type=script&lang=js"

import "./Forgot.vue?vue&type=style&index=0&id=698480a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698480a3"]])

export default __exports__